import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { Card, Form, Button, Spinner, Tab, Nav, Container, Col, Row } from 'react-bootstrap';
import Swal from 'sweetalert2';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import { useProvider, Toast } from '../context/MenuProvider';

import ReactMarkdown from 'react-markdown';
import AOS from "aos";
import 'aos/dist/aos.css';

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
dayjs.locale("pt-br");

const getColor = (data, pago, ativo=true) => {
      const dataPagamento = dayjs(data).startOf('day');
      const hoje = dayjs().startOf('day');
  
      if (pago) return 'green';
      if (dataPagamento.isSame(hoje)) return 'orange';
      if (dataPagamento.isBefore(hoje)) return 'red';
      if (dataPagamento.isBefore(hoje)) return 'red';
      if (!ativo) return 'black';
      return 'inherit';
};


const PagamentosLembrete = () => {
  const { crud, hasPerms } = useProvider();
  const navigate = useNavigate();
  const { tipo } = useParams();

  const tabs = [
    { key: "hoje", label: "Receber", perm: "loja.view_venda", component: <Proximos /> },
    { key: "pagar", label: "Pagar", perm: "financas.view_financeiro", component: <Pagar /> },
    { key: "atrasados", label: "Atrasados", perm: "loja.view_venda", component: <Atrasados /> },
    { key: "inadimplentes", label: "Inadimplentes", perm: "loja.view_venda", component: <Inadimplentes /> },
  ].filter(tab => hasPerms(tab.perm));

  return (
    <Tab.Container
      id="details-tabs"
      activeKey={tipo}
      onSelect={(k) => navigate(`/pagamentos/status/${k}`, { replace: true })}
    >
      <Nav variant="tabs" className="justify-content-center">
        {tabs.map(tab => (
          <Nav.Item key={tab.key}>
            <Nav.Link eventKey={tab.key}>{tab.label}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      <Tab.Content>
        {tabs.map(tab => (
          tipo === tab.key && <React.Fragment key={tab.key}>{tab.component}</React.Fragment>
        ))}
      </Tab.Content>
    </Tab.Container>
  );
};

const Proximos = () => {
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      buscarDadosPorId,
      setTitle,
    } = useProvider();
    const { get, post, loading } = crud || {};
    const [pagamentos, setPagamentos] = useState([]);
    const [extra, setExtra] = useState(null);
    const [nextUrl, setNextUrl] = useState(null);
    const [dataFim, setDataFim] = useState('');
    const [dias, setDias] = useState(0);
    const [paginaDB, setPaginaDB] = useState(1);
    const _hoje = new Date().toLocaleDateString('sv-SE')

    setTitle("Receber")
    
    let web;
    const buscarGeral = (novaBusca = false) => {
      buscarPagamentos(novaBusca);
      carregarLocal(novaBusca);
    }
    
    const isConsultaCarregada = useRef(false);
    const carregarLocal = async(novaBusca = false)=>{
      try{
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        
        const response = await buscarDados(
            'db_pagamentos',  
            (item) => {
                const dataItem = new Date(item.data_do_pagamento).getTime();
                const dataLimite = new Date(dataFim).getTime();
                const hoje = new Date().toLocaleDateString('sv-SE');
                const dataHoje = new Date(hoje).getTime();
                return item.venda &&
                       !item.pago &&
                       dataItem >= dataHoje &&
                       dataItem <= dataLimite;
            },
            50,
            "data_do_pagamento",
            "asc",
            paginaDB
        );
        
        if (isConsultaCarregada.current) return;
        if (response && response.length){
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => {
              const novos = Array.isArray(response) ? response : [response];
            
              const filtrados = novos.filter(
                (item) => !prev.some((p) => p.id === item.id)
              );
            
              return [...prev, ...filtrados];
            });
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
      } finally {

      }
    }
    
    useEffect(()=>{
      if (isConsultaCarregada.current) return;
      setExtra(pagamentos.reduce((total, x) => parseFloat(total || 0) + parseFloat(x.valor_total || 0), 0));
    }, [pagamentos])

    
    // Função para buscar pagamentos na API
    const buscarPagamentos = async (novaBusca = false) => {
        let url = `/gvendas/pagamentos/?venda__isnull=false&pago=false&data_do_pagamento__gte=${_hoje}&data_do_pagamento__lte=${dataFim}&expand=venda,cliente,regiao,extra&filtros=nome_do_cliente,is_inadimplente,nome,forma_de_pagamento,pago,id,valor_total,data_do_pagamento,referencia,ativo&ordering=data_do_pagamento`;
        
        if (novaBusca) {
            //setPagamentos([]);
            setNextUrl(null);
            //carregarLocal();
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, "pagamentos");
          //alert(JSON.stringify(response))
          if (response && response.length){
            isConsultaCarregada.current = true;
            const novosVendas = response[0].results;
            setPagamentos((pagamentosAnteriores) => novaBusca ? novosVendas : [...pagamentosAnteriores, ...novosVendas]);
            setNextUrl(response[0].next);
            setExtra(response[0].extra?.total);
          }
          
        }catch(err){
          //alert(JSON.stringify(err))
          
        }finally{
          
        }
    };
    
    useEffect(() => {
      const diasInt = parseInt(dias) || 0;
      const hoje = new Date();
      hoje.setDate(hoje.getDate() + diasInt);
      
      // Formatação correta da data
      setDataFim(hoje.toLocaleDateString('sv-SE'));
    }, [dias]);


    // Carrega todos os pagamentos ao montar o componente ou ao aplicar um novo filtro
    useEffect(() => {
      if(dataFim){
        buscarGeral(true);
      }
    }, [dataFim]);

    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarPagamentos();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    
    useEffect(() => {
      setLinks([
        { name: 'Hoje', onClick:()=> { setDias(0) }},
        { name: 'Até amanhã', onClick:()=> { setDias(1) }},
        { name: 'Próximos 7 dias', onClick:()=> { setDias(7) }},
        { name: 'Próximos 15 dias', onClick:()=> { setDias(15) }},
        { name: 'Próximos 30 dias', onClick:()=> { setDias(30) }},
        //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      setBtns([
        //{ name: 'Perfil', to: '/' },
        //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns]);
    
    
    const pagamentosAgrupadas = pagamentos.reduce((acc, pagamento) => {
      const data = pagamento.data_do_pagamento; // Assumindo que data_do_pagamento está no formato desejado
      //const data = pagamento.data_do_pagamento; // Assumindo que data_do_pagamento está no formato desejado
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(pagamento);
      return acc;
    }, {});
    
    
    const geralAgrupadas = Object.entries(pagamentosAgrupadas).reduce((acc, [data, pagamentosDoDia]) => {
      acc[data] = {};
    
      pagamentosDoDia.forEach(pagamento => {
        const regiao = pagamento.venda?.cliente?.regiao?.nome || 'Sem Região';
    
        if (!acc[data][regiao]) {
          acc[data][regiao] = {};
        }
    
        const clienteId = pagamento.venda?.cliente?.id;
        if (!acc[data][regiao][clienteId]) {
          acc[data][regiao][clienteId] = {
            id: clienteId,
            nome: pagamento.venda?.cliente?.nome,
            valor: 0,
            pagamentos: []
          };
        }
    
        acc[data][regiao][clienteId].valor += pagamento.valor_total;
        acc[data][regiao][clienteId].pagamentos.push(pagamento);
      });
    
      // Se quiser transformar clientes em array por região
      Object.keys(acc[data]).forEach(regiao => {
        acc[data][regiao] = Object.values(acc[data][regiao]);
      });
    
      return acc;
    }, {});


    return (
      <>
        <MenuRodape total={extra} dias={dias}/>
        <div className="">
          <div className="list-group mt-3">
            {Object.entries(geralAgrupadas).length > 0 ? (
                Object.entries(geralAgrupadas).map(([data, regioes]) => (
                  <div key={data}>
                    <div className="text-muted mt-3">{dayjs(data).format("DD/MM/YYYY dddd")}</div>
                    {Object.entries(regioes).map(([regiao, clientes]) => (
                      <div key={regiao}>
                        {regiao && <div className="text-muted ps-3"><i className="bi bi-geo-alt"></i> {regiao}</div>}
                        {clientes.map(cliente => (
                          <div key={cliente.nome} className="">
                            <RenderizarProduto
                                //key={pagamento.id}
                                to={`/clientes/${cliente.id}/`}
                                lm='mb-1'
                                col='d-none'
                                bcolor={getColor(data, false)}
                                col2='col-auto text-end'
                                text1={cliente.nome}
                                titulo3={parseFloat(cliente.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                text2={(<>
                                  {cliente.pagamentos?.length === 1 ? (<>
                                    {cliente.pagamentos[0].referencia}
                                  </>) : (<>
                                    Ref: {parseInt(cliente.pagamentos?.length||0)} compra{cliente.pagamentos.length>1?"s":""}
                                  </>)}
                                </>)}
                                text3={'receber'}
                              />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))
            ) : (
                !(loading) && <p data-aos="fade-up" className="text-center text-muted">Nenhum pagamento encontrado.</p>
            )}
            {(loading) && <p data-aos="fade-up" className="text-center"><Spinner animation="border" /></p>}
            {nextUrl && !(loading) && (
              <Button variant="secondary" data-aos="fade-up" onClick={() => buscarPagamentos(false)} className="mt-2">
                Buscar mais...
              </Button>
            )}
          </div>
        </div>
      </>
    );
};
const Pagar = () => {
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      buscarDadosPorId,
    } = useProvider();
    const { get, post, loading } = crud || {};
    const [pagamentos, setPagamentos] = useState([]);
    const [extra, setExtra] = useState(null);
    const [nextUrl, setNextUrl] = useState(null);
    const [dataFim, setDataFim] = useState('');
    const [dias, setDias] = useState(0);
    const [paginaDB, setPaginaDB] = useState(1);
    
    let web;
    const buscarGeral = (novaBusca = false) => {
      buscarPagamentos(novaBusca);
      carregarLocal(novaBusca);
    }


  
    const carregarLocal = async(novaBusca = false)=>{
      try{
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        const response = await buscarDados(
            'db_pagamentos',  
            (item) => {
                const dataItem = new Date(item.data_do_pagamento).getTime();
                const dataLimite = new Date(dataFim).getTime();
                const hoje = new Date().toLocaleDateString('sv-SE');
                const dataHoje = new Date(hoje).getTime();
                return item.financeiro &&
                       !item.pago &&
                       dataItem >= dataHoje &&
                       dataItem <= dataLimite;
            },
            50,
            "data_do_pagamento",
            "asc",
            paginaDB
        );
        
        if (web){
          web = false;
          return; 
        }
        if (response && response.length){
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => {
              const novos = Array.isArray(response) ? response : [response];
            
              const filtrados = novos.filter(
                (item) => !prev.some((p) => p.id === item.id)
              );
            
              return [...prev, ...filtrados];
            });
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
      } finally {

      }
    }

    
    // Função para buscar pagamentos na API
    const buscarPagamentos = async (novaBusca = false) => {
        let url = `/gvendas/pagamentos/?financeiro__isnull=false&pago=false&data_do_pagamento__lte=${dataFim}&expand=financeiro,categoria&ordering=-data_do_pagamento`;
        
        if (novaBusca) {
            //setPagamentos([]);
            setNextUrl(null);
            //carregarLocal();
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, "pagamentos");
          if (response && response.length){
            const novosVendas = response[0].results;
            setPagamentos((pagamentosAnteriores) => novaBusca ? novosVendas : [...pagamentosAnteriores, ...novosVendas]);
            setNextUrl(response[0].next);
            setExtra(response[0].extra?.soma);
          }
          
        }catch(err){
          
        }finally{
          
        }
    };
    
    useEffect(() => {
      const diasInt = parseInt(dias) || 0;
      const hoje = new Date();
      hoje.setDate(hoje.getDate() + diasInt);
      
      // Formatação correta da data
      setDataFim(hoje.toLocaleDateString('sv-SE'));
    }, [dias]);

    // Carrega todos os pagamentos ao montar o componente ou ao aplicar um novo filtro
    useEffect(() => {
      if(dataFim){
        //buscarPagamentos(true);
        buscarGeral(true);
      }
    }, [dataFim]);

    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarPagamentos();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    
    useEffect(() => {
      setLinks([
        { name: 'Hoje', onClick:()=> { setDias(0) }},
        { name: 'Até amanhã', onClick:()=> { setDias(1) }},
        { name: 'Próximos 7 dias', onClick:()=> { setDias(7) }},
        { name: 'Próximos 15 dias', onClick:()=> { setDias(15) }},
      ]);
      setBtns([
        //{ name: 'Perfil', to: '/' },
        //{ name: 'Configurações', to: '/configuracoes' },
      ]);
      return () => {setLinks([]); setBtns([]);}
    }, [setLinks, setBtns]);
    
    
    const pagamentosAgrupadas = pagamentos.reduce((acc, pagamento) => {
      const data = dayjs(pagamento.data_do_pagamento).format("DD/MM/YYYY dddd"); // Assumindo que data_do_pagamento está no formato desejado
      //const data = pagamento.data_do_pagamento; // Assumindo que data_do_pagamento está no formato desejado
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(pagamento);
      return acc;
    }, {});
    
    const geralAgrupadas = Object.keys(pagamentosAgrupadas).reduce((acc, data) => {
      acc[data] = pagamentosAgrupadas[data].reduce((subAcc, pagamento) => {
        const regiao = pagamento.venda?.cliente?.regiao?.nome || ''; // Agrupar por regiao_do_cliente
        if (!subAcc[regiao]) {
          subAcc[regiao] = [];
        }
        subAcc[regiao].push(pagamento);
        return subAcc;
      }, {});
      return acc;
    }, {});
    
    const getCor = (x) => {
      const hoje = dayjs(); // data atual
      const pagamento = dayjs(x.data_do_pagamento);
      if(x.pago) return 'green';
      if (pagamento.isSame(hoje, 'day')) return 'orange'; // mesmo dia
      if (pagamento.isBefore(hoje, 'day')) return 'red';  // data anterior
      
      return '';
    };

    return (
      <>
        <MenuRodape total={extra} dias={dias}/>
        <div className="">
          <div className="list-group mt-3">
            {Object.entries(geralAgrupadas).length > 0 ? (
              Object.entries(geralAgrupadas).map(([data, regioes], index) => (
                <div key={data}>
                  <div className="text-muted mt-3">{data}</div>
                  {Object.entries(regioes).map(([regiao, pagamentosDaRegiao], index_f) => (
                    <div key={regiao} className="">
                      {regiao && <div className="text-muted ps-3"><i class="bi bi-geo-alt"></i>{regiao}</div>}
                      {pagamentosDaRegiao.map((x) =>(
                        <div>
                          <RenderizarProduto
                            to={`/despesas/editar/${parseInt(x.financeiro?.id || x.financeiro)}/${x.financeiro?.categoria?.tipo||``}`}
                            lm= 'mb-1'
                            // icon: x.img_status,
                            col='d-none'
                            bcolor={getColor(x.data_do_pagamento, x.pago, x)}
                            col2= 'col-auto text-end'
                            text1= {x.financeiro?.categoria?.nome ||``}
                            titulo3= {parseFloat(x.valor_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            // text2: `Pago: ${parseFloat(x.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })} em aberto ${parseFloat(x.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}`,
                            text2={`${x.financeiro?.observacoes || ``}`}
                            text3={x.pago ? 'pago' : 'pagar'}
                          />
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))
            ) : (
                !(loading) && <p data-aos="fade-up" className="text-center text-muted">Nenhum pagamento encontrado.</p>
            )}
            {(loading) && <p data-aos="fade-up" className="text-center"><Spinner animation="border" /></p>}
            {nextUrl && !(loading) && (
              <Button variant="secondary" data-aos="fade-up" onClick={() => buscarPagamentos(false)} className="mt-2">
                Buscar mais...
              </Button>
            )}
          </div>
        </div>
      </>
    );
};
const Atrasados = () => {
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      buscarDadosPorId,
      setTitle,
    } = useProvider();
    const { get, post, loading } = crud || {};
    const [pagamentos, setPagamentos] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [extra, setExtra] = useState(null);
    const [paginaDB, setPaginaDB] = useState(1);
    
    setTitle("Atrasados")
    
    let web;
    const buscarGeral = (novaBusca = false) => {
      buscarPagamentos(novaBusca);
      carregarLocal(novaBusca);
    }


    const isConsultaCarregada = useRef(false);
    const carregarLocal = async(novaBusca = false)=>{
      try{
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        const response = await buscarDados(
            'db_pagamentos',  
            (item) => {
                const dataItem = new Date(item.data_do_pagamento).getTime();
                const hoje = new Date().toLocaleDateString('sv-SE');
                const dataLimite = new Date(hoje).getTime();
                return item.venda?.id &&
                       !item.pago &&
                       !item.venda?.cliente?.is_inadimplente &&
                       dataItem < dataLimite
                       
            },
            50,
            "data_do_pagamento",
            "desc",
            paginaDB
        );
        if (isConsultaCarregada.current) return;
        if (response && response.length){
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => {
              const novos = Array.isArray(response) ? response : [response];
            
              const filtrados = novos.filter(
                (item) => !prev.some((p) => p.id === item.id)
              );
            
              return [...prev, ...filtrados];
            });
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
        // alert("erro local")
        // alert(JSON.stringify(err))
      } finally {

      }
    }


    
    useEffect(()=>{
      buscarGeral(true);
    },[setPagamentos])
    
    useEffect(()=>{
      if (isConsultaCarregada.current) return;
      setExtra(pagamentos.reduce((total, x) => parseFloat(total || 0) + parseFloat(x.valor_total || 0), 0));
    }, [pagamentos])
    
    // Função para buscar pagamentos na API
    const buscarPagamentos = async (novaBusca = false) => {
        const hoje = new Date().toLocaleDateString('sv-SE');
        let url = `/gvendas/pagamentos/?venda__isnull=false&data_do_pagamento__lt=${hoje}&pago=false&venda__cliente__is_inadimplente=false&expand=venda,cliente,extra&filtros=nome_do_cliente,is_inadimplente,nome,referencia,pago,id,valor_total,data_do_pagamento,ativo&ordering=-data_do_pagamento`;

        if (novaBusca) {
            // setPagamentos([]);
            setNextUrl(null);
            // carregarLocal();
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, "pagamentos");
          if (response && response.length){
            isConsultaCarregada.current = true;
            const novosVendas = response[0].results;
            setPagamentos((pagamentosAnteriores) => novaBusca ? novosVendas : [...pagamentosAnteriores, ...novosVendas]);
            setNextUrl(response[0].next);
            setExtra(response[0].extra?.total);
          }
          
        }catch(err){

        }finally{
          
        }
    };


    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarPagamentos();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    

    const pagamentosAgrupadas = pagamentos.reduce((acc, pagamento) => {
      const data = pagamento.data_do_pagamento;
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(pagamento);
      return acc;
    }, {});
    const geralAgrupadas = Object.entries(pagamentosAgrupadas).reduce((acc, [data, pagamentosDoDia]) => {
      acc[data] = {};
    
      pagamentosDoDia.forEach(pagamento => {
        const regiao = pagamento.venda?.cliente?.regiao?.nome || 'Sem Região';
    
        if (!acc[data][regiao]) {
          acc[data][regiao] = {};
        }
    
        const clienteId = pagamento.venda?.cliente?.id;
        if (!acc[data][regiao][clienteId]) {
          acc[data][regiao][clienteId] = {
            id: clienteId,
            ativo: pagamento.venda?.cliente?.ativo,
            nome: pagamento.venda?.cliente?.nome,
            valor: 0,
            pagamentos: []
          };
        }
    
        acc[data][regiao][clienteId].valor += pagamento.valor_total;
        acc[data][regiao][clienteId].pagamentos.push(pagamento);
      });
    
      // Se quiser transformar clientes em array por região
      Object.keys(acc[data]).forEach(regiao => {
        acc[data][regiao] = Object.values(acc[data][regiao]);
      });
    
      return acc;
    }, {});

    
    return (
      <>
        <MenuRodape total={extra}/>
        <div className="list-group mt-3">
            {Object.entries(geralAgrupadas).length > 0 ? (
                Object.entries(geralAgrupadas).map(([data, regioes]) => (
                  <div key={data}>
                    <div className="text-muted mt-3">{dayjs(data).format("DD/MM/YYYY dddd")}</div>
                    {Object.entries(regioes).map(([regiao, clientes]) => (
                      <div key={regiao}>
                        {regiao && <div className="text-muted ps-3"><i className="bi bi-geo-alt"></i> {regiao}</div>}
                        {clientes.map(cliente => (
                          <div key={cliente.nome} className="">
                            <RenderizarProduto
                                //key={pagamento.id}
                                to={`/clientes/${cliente.id}/`}
                                lm='mb-1'
                                col='d-none'
                                bcolor={getColor(data, false, cliente.ativo)}
                                col2='col-auto text-end'
                                text1={cliente.nome}
                                titulo3={parseFloat(cliente.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                text2={(<>
                                  {cliente.pagamentos?.length === 1 ? (<>
                                    {cliente.pagamentos[0].referencia}
                                  </>) : (<>
                                    Ref: {parseInt(cliente.pagamentos?.length||0)} compra{cliente.pagamentos.length>1?"s":""}
                                  </>)}
                                </>)}
                                text3={'receber'}
                              />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                ))
            ) : (
                !(!loading) && <p data-aos="fade-up" className="text-center text-muted">Nenhum pagamento encontrado.</p>
            )}
            {(loading) && <p data-aos="fade-up" className="text-center"><Spinner animation="border" /></p>}
            {nextUrl && !(!loading) && (
              <Button variant="secondary" data-aos="fade-up" onClick={() => buscarPagamentos(false)} className="mt-2">
                  Buscar mais...
              </Button>
            )}
          </div>
      </>
    );
};
const Inadimplentes = () => {
    const { 
      setLinks, 
      setBtns,
      crud,
      buscarDados,
      buscarDadosPorId,
      setTitle,
    } = useProvider();
    const { get, post, loading } = crud || {};
    const [pagamentos, setPagamentos] = useState([]);
    const [nextUrl, setNextUrl] = useState(null);
    const [extra, setExtra] = useState(null);
    const [isCalote, setIsCalote] = useState(false);
    const [paginaDB, setPaginaDB] = useState(1);
    
    
    useEffect(()=>{
      setTitle(isCalote?"Perdas":"Inadimplentes");
    }, [isCalote])
    
    useEffect(()=>{
      if (isConsultaCarregada.current) return;
      setExtra(pagamentos.reduce((total, x) => parseFloat(total || 0) + parseFloat(x.valor_total || 0), 0));
    }, [pagamentos])
    
    const buscarGeral = (novaBusca = false) => {
      buscarPagamentos(novaBusca);
      carregarLocal(novaBusca);
    }


    const isConsultaCarregada = useRef(false);
    const carregarLocal = async(novaBusca = false)=>{
      try{
        if(novaBusca){
          setPagamentos([]);
        } else if(paginaDB === 0) return;
        const response = await buscarDados(
            'db_pagamentos',  
            (item) => {
                const dataItem = new Date(item.data_do_pagamento).getTime();
                const hoje = new Date().toLocaleDateString('sv-SE');
                const dataLimite = new Date(hoje).getTime();
                let ativo = false;
                if (!isCalote) ativo = !!item.venda?.cliente?.ativo;
                return item.venda &&
                       !item.pago &&
                       item.venda?.cliente?.is_inadimplente &&
                       ativo &&
                       dataItem < dataLimite
                       
            },
            50,
            "data_do_pagamento",
            "desc",
            paginaDB
        );
        if (isConsultaCarregada.current) return;
        if (response && response.length){
          if(novaBusca){
            setPagamentos(response);
            setPaginaDB(1);
          }else{
            setPagamentos((prev) => {
              const novos = Array.isArray(response) ? response : [response];
            
              const filtrados = novos.filter(
                (item) => !prev.some((p) => p.id === item.id)
              );
            
              return [...prev, ...filtrados];
            });
            setPaginaDB(paginaDB+1);
          }
        }else{
          setPaginaDB(0);
        }
      }catch(err){
      } finally {
        
      }
    }

    
    // Função para buscar pagamentos na API
    const buscarPagamentos = async (novaBusca = false) => {
        const hoje = new Date().toLocaleDateString('sv-SE')
        let url = `/gvendas/pagamentos/?venda__lt=0&expand=venda,cliente,extra&filtros=nome_do_cliente,is_inadimplente,nome,referencia,pago,id,valor_total,data_do_pagamento,data_da_venda,ativo&pago=false&ordering=-venda__data_da_venda`;
        if (!isCalote){
          url+=`&venda__cliente__is_inadimplente=true`
        }else{
          url+=`&venda__cliente__ativo=false`
        }
        if (novaBusca) {
            // setPagamentos([]);
            setNextUrl(null);
        } else if (nextUrl) {
            url = nextUrl;
        } else {
            url = null;
        }

        if (!url) return;
        try{
          const response = await get(url, "pagamentos");
          if (response && response.length){
            isConsultaCarregada.current = true;
            const novosVendas = response[0].results;
            setPagamentos((pagamentosAnteriores) => novaBusca ? novosVendas : [...pagamentosAnteriores, ...novosVendas]);
            setNextUrl(response[0].next);
            setExtra(response[0].extra?.total)
          }
          
        }catch(err){
          
        }finally{
          
        }
    };

    // Carrega todos os pagamentos ao montar o componente ou ao aplicar um novo filtro
    useEffect(()=>{
      buscarGeral(true);
    },[isCalote])

    // Detecta o fim da página para carregar mais pagamentos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarPagamentos();
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [nextUrl, loading]);
    
    
    
    const pagamentosAgrupadas = pagamentos.reduce((acc, pagamento) => {
      const data = dayjs(pagamento.venda.data_da_venda).format("DD/MM/YYYY dddd");
      if (!acc[data]) {
        acc[data] = [];
      }
      acc[data].push(pagamento);
      return acc;
    }, {});
    
    return (
      <>
        <MenuRodape total={extra}/>
        <ReactMarkdown>
            **Atenção:**  
            Nesta seção são listados os clientes que estão há mais de 90 dias sem realizar nenhum pagamento das dívidas em aberto.  
            São considerados clientes com histórico de inadimplência e devem ser acompanhados com cautela.
        </ReactMarkdown>
        <Form.Group controlId="formCalote" className="mt-3">
          <Form.Check 
            type="switch" 
            label="Clientes desativados"
            checked={isCalote} 
            onChange={(e) => 
            setIsCalote(!isCalote)
          }
        />
        </Form.Group>
        <div className="list-group mt-3">
            {Object.entries(pagamentosAgrupadas).length>0?(
              Object.entries(pagamentosAgrupadas).map(([data, pagamentosDoDia], index) => (
                <div key={data}>
                  <div className="text-muted mt-2">Venda em {data}</div>
                    {pagamentosDoDia.map((x, index_f) => (
                      <div>
                        <RenderizarProduto
                          to={`/vendas/${x.venda.id}/${x.id}`}
                          key={x.id}
                          lm="mb-1"
                          bcolor={x.venda?.cliente?.ativo?"red":"black"}
                          col="d-none"
                          col2="col-auto text-end"
                          text1={x.venda?.cliente?.nome || x.venda?.cliente?.nome_do_cliente}
                          titulo3={parseFloat(x.valor_total).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                          text2={`${x.venda?.cliente?.ativo?"Negativado":"Bloqueado"}`}
                          text3={x.pago ? 'recebido' : 'receber'}
                        />
                      </div>
                    ))}
                  </div>
              ))
            ) : (
                !(!loading) && <p data-aos="fade-up" className="text-center text-muted">Nenhum pagamento encontrado.</p>
            )}
            {(loading) && <p data-aos="fade-up" className="text-center"><Spinner animation="border" /></p>}
            {nextUrl && !(!loading) && (
              <Button variant="secondary" data-aos="fade-up" onClick={() => buscarPagamentos(false)} className="mt-2">
                  Buscar mais...
              </Button>
            )}
          </div>
      </>
    );
};

const MenuRodape = ({ total, dias }) => {
  if (parseFloat(total || 0)<=0) return null;

  return (
    <div className="bs-floating shadow navbar-light">
      <Container className="py-1">
        <Row className="align-items-center">
          <Col>
            {dias>0 ? dias>1?`Próximos ${dias} dias`:'Até amanhã':dias===0?'Hoje':''}
          </Col>
          <Col className="text-end">
            Total {' '} 
            <span className="fs-4">
              {parseFloat(total||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PagamentosLembrete;